import { CategoryRegistry } from "@/lib/catalog/registry";

type NavLink = { to: string; label: string; exact?: boolean };

export const NAV_LINKS: readonly NavLink[] = [
  { to: "/", label: "Home", exact: true },
  { to: "/shop", label: "Shop" },
  { to: "/fragrances", label: "Fragrances" },
  { to: "/collections", label: "Collections" },
  // Temporary testing link for the Pack Builder demo.
  { to: "/packs", label: "Discovery Packs" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const AUTH_ROUTES = new Set(["/login", "/signup", "/forgot-password", "/reset-password", "/verify-email"]);

/**
 * Registry-driven shop links. Adding a new category plugin automatically
 * populates the shop menu — no nav changes required (AP-11).
 */
export type ShopLink = { slug: string; label: string; tagline: string; comingSoon: boolean };

export function getShopLinks(): ShopLink[] {
  return CategoryRegistry.all().map((p) => ({
    slug: p.metadata.slug,
    label: p.metadata.name,
    tagline: p.metadata.tagline,
    comingSoon: p.metadata.status === "coming-soon",
  }));
}
